import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { App } from './App';
import { QuizPage } from './pages/QuizPage';
import { MetaPixel } from './components/MetaPixel';
export function AppRouter() {
  return <HelmetProvider data-id="element-44">
      <BrowserRouter data-id="element-45">
        <MetaPixel data-id="element-46" />
        <Routes data-id="element-47">
          <Route path="/" element={<App data-id="element-49" />} data-id="element-48" />
          <Route path="/quiz" element={<QuizPage data-id="element-51" />} data-id="element-50" />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>;
}